module.exports = __webpack_public_path__ + "media/images/icons/form_hero__btn-520500e3cd2f1ae4deb7866a48eb8849.png";